import { AuthState, AuthActionTypes } from './types';
import { Reducer } from 'redux';
import { SharedActionTypes } from '../shared/types';

const initialState: AuthState = {
  loading: false,
  data: undefined,
  errors: undefined
};

const reducer: Reducer<AuthState> = (state = initialState, action) => {
  switch (action.type) {
    case AuthActionTypes.LOGIN_REQUEST: {
      return { ...state, loading: true };
    }
    case AuthActionTypes.LOGIN_SUCCESS: {
      return { ...state, loading: false, data: action.payload };
    }
    case AuthActionTypes.LOGIN_FAILURE: {
      return { ...state, loading: false, errors: action.payload };
    }
    case AuthActionTypes.LOGOUT: {
      return { ...state, data: undefined };
    }
    case AuthActionTypes.SET_IMAGE: {
      return {
        ...state,
        data: {
          ...state.data,
          image: action.payload
        }
      };
    }
    case AuthActionTypes.SET_USER: {
      return { ...state, data: action.payload };
    }
    case SharedActionTypes.RESET: {
      return initialState;
    }
    default:
      return state;
  }
};

export { reducer as AuthReducer };



// WEBPACK FOOTER //
// ./src/store/auth/reducer.ts